import download from 'downloadjs'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { getRangeFromDateFilter } from 'utils/dateUtils'
import { wrapCSVTextToBlob, xhrExtractFileName } from 'utils/helpers'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  fetchActivitiesCSVError,
  fetchActivitiesCSVSuccess,
  fetchActivitiesError,
  fetchActivitiesSuccess,
  fetchAllActivitiesFiltersError,
  fetchAllActivitiesFiltersSuccess,
} from './actions'
import {
  ACTIVITIES_CSV_PER_PAGE,
  ACTIVITIES_PER_PAGE,
  CREATED_BY_FILTER_CHANGE,
  DATE_FILTER_CHANGE,
  EVENTS_FILTER_CHANGE,
  FETCH_ACTIVITIES_ASYNC,
  FETCH_ACTIVITIES_CSV_ASYNC,
  FETCH_ALL_FILTERS_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SORT_PROPERTY_CHANGE,
  TARGETS_FILTER_CHANGE,
} from './constants'

const fetchActivitiesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_ACTIVITIES_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      EVENTS_FILTER_CHANGE,
      CREATED_BY_FILTER_CHANGE,
      TARGETS_FILTER_CHANGE,
      DATE_FILTER_CHANGE,
      SEARCH_CHANGE,
      PAGINATE_CHANGE,
      SORT_PROPERTY_CHANGE
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.activities.self)
      return true
    })
    .mergeMap(() =>
      api.accounts
        .getActivities(
          store.getState().partnerOptions.selectedCompany?.value,
          false,
          store.getState().activities.self.sortProperty,
          getRangeFromDateFilter(store.getState().activities.self.dateFilter),
          store.getState().activities.self.selectedEventType,
          store.getState().activities.self.selectedTargets,
          store.getState().activities.self.createdBy,
          store.getState().activities.self.page,
          store.getState().activities.self.search,
          ACTIVITIES_PER_PAGE
        )
        .map(({ response }) => fetchActivitiesSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchActivitiesError, error)))
        .takeUntil(action$.ofType(FETCH_ACTIVITIES_ASYNC.CANCEL))
    )

const fetchActivitiesCSVEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(FETCH_ACTIVITIES_CSV_ASYNC.INITIATE).mergeMap(() =>
    api.accounts
      .getActivities(
        store.getState().partnerOptions.selectedCompany?.value,
        true,
        store.getState().activities.self.sortProperty,
        getRangeFromDateFilter(store.getState().activities.self.dateFilter),
        store.getState().activities.self.selectedEventType,
        store.getState().activities.self.selectedTargets,
        store.getState().activities.self.createdBy,
        store.getState().activities.self.page,
        store.getState().activities.self.search,
        ACTIVITIES_CSV_PER_PAGE
      )
      .map((response) => {
        download(
          wrapCSVTextToBlob(response.response),
          xhrExtractFileName(response.xhr),
          response.responseType
        )
        return fetchActivitiesCSVSuccess(response)
      })
      .catch((error) => Observable.of(epicsErrorHandler(fetchActivitiesCSVError, error)))
      .takeUntil(action$.ofType(FETCH_ACTIVITIES_CSV_ASYNC.CANCEL))
  )

const fetchAllFiltersEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_ALL_FILTERS_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.activities.self)
      return true
    })
    .mergeMap(() =>
      api.accounts
        .getActivitiesFilters(store.getState().partnerOptions.selectedCompany?.value)
        .map(({ response }) => fetchAllActivitiesFiltersSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchAllActivitiesFiltersError, error)))
    )

export default combineEpics(fetchActivitiesEpic, fetchActivitiesCSVEpic, fetchAllFiltersEpic)
